<template>
  <div id="app" class="h-screen" :class="{ dark: isDarkMode }">
    <nav></nav>
    <div v-if="!loading" class="h-full">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <div v-else>
      <div class="espera"></div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    isDarkMode() {
      return this.$store.state.isDarkMode;
    },
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },
  },
  mounted() {
    document.title = "Núria Jordán";
  },
  watch: {
    isDarkMode(newValue) {
      // Cambia la clase dark en el html globalmente
      document.documentElement.classList.toggle("dark", newValue);
    },
    currentLanguage(newLang) {
      // Actualiza el idioma de la aplicación
      this.$i18n.locale = newLang;
    },
  },
  created() {
    // Recupera la preferencia del tema al iniciar
    if (this.isDarkMode) {
      document.documentElement.classList.add("dark");
    }
    this.$i18n.locale = this.currentLanguage;
  },
};
</script>

<style lang="scss">
#app {
  font-family: Lemur, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overscroll-behavior: none;
  height: 100vh;
  overflow-x: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
